import script from "./PhoneForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneForm.vue?vue&type=script&setup=true&lang=js"

import "./PhoneForm.vue?vue&type=style&index=0&id=77321932&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77321932"]])

export default __exports__